module.exports = __webpack_public_path__ + "img/va.7fdd3054.svg";